<template>
    <div id="single-product__review" class="single-product__review" >
        <div class="stamped-header-title">
            What Our Buyers Say
        </div>
        <div
            id="stamped-main-widget"
            :data-product-id="review.id"
            :data-name="review.name"
            :data-url="review.url"
            :data-image-url="review.image"
            :data-description="review.description"
            :data-product-sku="review.sku">
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_review.scss";
</style>

<script setup lang="ts">
    const props = defineProps(["data"]);
    const review = computed(() => props.data);
    import { useRoute } from 'vue-router';
    const route = useRoute();
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const fullUrl = `${baseUrl}${route.fullPath}`;
    const emit = defineEmits<{
        (e: 'handle-aggregate-rating', reviewSchema: any): void;
    }>();

    const stamped = ref({
    apiKey: "67a493e9-b709-4443-8008-b3538dde4d34",
        storeUrl: "",
    storeHash: "304041",
    });

    const product = ref({});

    const initializeStamped = () => {
    // Initialize Stamped widget after the script has loaded
        StampedFn.init({
        apiKey: '67a493e9-b709-4443-8008-b3538dde4d34', // Replace with your actual API key
        sId: '304041' // Replace with your actual store hash
        });
    };

    const initializeStampedWhenReady = () => {
        if (typeof StampedFn !== 'undefined') {
            initializeStamped();
            return;
        }
        window.addEventListener('stamped:script-loaded', initializeStamped, { once: true });
    };

//     const url = `https://stamped.io/api/widget?productId=638617&page=1&apiKey=pubkey-oJ7Nw9v4HP3M976Bu62qbX9qm3Y7m2&sId=210582&take=5`;

// fetch(url)
//   .then(res => res.json())
//   .then(data => {
//     console.log('----- data: ',data)
//     const { rating, count } = data;
//     // dùng rating, count ở đây
//   });
  
    const aggregateRating = ref();
    const reviewDatas = ref<any[]>([]);
    let showMoreBtn: HTMLElement | null = null;
    let isShowMoreExpanded = false;

    const createShowMoreButton = () => {
        // If already expanded, don't create button
        if (isShowMoreExpanded) {
            return null;
        }
        
        if (!document.getElementById('show-more-btn')) {
            const btn = document.createElement('button');
            btn.id = 'show-more-btn';
            btn.textContent = 'Show More ';
            btn.style.display = 'block';
            btn.style.marginTop = '20px';
            btn.style.marginBottom = '20px';

            // Create the dropdown icon
            const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            svgElement.setAttribute('width', '24');
            svgElement.setAttribute('height', '24');
            svgElement.setAttribute('viewBox', '0 0 24 24');

            // Create the path element inside the SVG
            const pathElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            pathElement.setAttribute('fill', 'currentColor');
            pathElement.setAttribute('d', 'm12 15l-5-5h10z');

            // Append the path to the SVG
            svgElement.appendChild(pathElement);
            btn.appendChild(svgElement);
            
            // Find the 3rd review and insert button after it
            const reviews = document.querySelectorAll('.stamped-review');
            if (reviews.length > 2) {
                const thirdReview = reviews[2];
                thirdReview.parentNode?.insertBefore(btn, thirdReview.nextSibling);
            }
            
            showMoreBtn = btn;
            return btn;
        }
        return document.getElementById('show-more-btn');
    };

    const setupShowMoreButton = (stampQuestion: HTMLElement | null, stampReview: HTMLElement | null) => {
        const btn = createShowMoreButton();
        if (btn) {
            // Add event listener to toggle hidden reviews visibility
            btn.addEventListener('click', () => {
                isShowMoreExpanded = true;
                const hiddenReviews = document.querySelectorAll('.stamped-review[style*="display: none"]');
                hiddenReviews.forEach((review) => {
                    (review as HTMLElement).style.display = 'block';
                });
                // Show pagination
                const pagination = document.querySelectorAll('[class*="pagination"]');
                pagination.forEach((pag) => {
                    (pag as HTMLElement).style.display = 'block';
                });
                // Remove button from DOM
                btn.remove();
            });
            if (stampQuestion){
                stampQuestion.addEventListener('click', () => {
                    isShowMoreExpanded = true;
                    const hiddenReviews = document.querySelectorAll('.stamped-review[style*="display: none"]');
                    hiddenReviews.forEach((review) => {
                        (review as HTMLElement).style.display = 'block';
                    });
                    // Show pagination
                    const pagination = document.querySelectorAll('[class*="pagination"]');
                    pagination.forEach((pag) => {
                        (pag as HTMLElement).style.display = 'block';
                    });
                    // Remove button from DOM
                    const existingBtn = document.getElementById('show-more-btn');
                    if (existingBtn) existingBtn.remove();
                });
            }
            if (stampReview){
                stampReview.addEventListener('click', () => {
                    isShowMoreExpanded = true;
                    const hiddenReviews = document.querySelectorAll('.stamped-review[style*="display: none"]');
                    hiddenReviews.forEach((review) => {
                        (review as HTMLElement).style.display = 'block';
                    });
                    // Show pagination
                    const pagination = document.querySelectorAll('[class*="pagination"]');
                    pagination.forEach((pag) => {
                        (pag as HTMLElement).style.display = 'block';
                    });
                    // Remove button from DOM
                    const existingBtn = document.getElementById('show-more-btn');
                    if (existingBtn) existingBtn.remove();
                });
            }
        }
    };

    onMounted(() => {
        const stampedWidget = document.getElementById('stamped-main-widget');
        if (stampedWidget) {

        // Create a MutationObserver to watch for changes in the DOM
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        // Check if reviews have been added
                        const reviews = stampedWidget.querySelectorAll('.stamped-review');
                        if (reviews.length > 0) {
                            // Stop observing once the reviews are loaded
                            observer.disconnect();
                        }
                    }
                }
            });

        // Start observing the stampedWidget for changes
            observer.observe(stampedWidget, { childList: true, subtree: true });
        }
        initializeStampedWhenReady();

        const addEventListenerStamped = (el, eventName, handler) => {
            if (el.addEventListener) { el.addEventListener(eventName, handler); }
            else { el.attachEvent('on' + eventName, function () { handler.call(el); }); }
        }
        addEventListenerStamped(document, 'stamped:reviews:loaded', function(e) {
            var reviewCount = jQueryStamped('meta[itemprop="reviewCount"]').attr('content');
            var ratingValue = jQueryStamped('meta[itemprop="ratingValue"]').attr('content');
            var ratingCount = jQueryStamped('meta[itemprop="reviewCount"]').attr('content');
            var bestRating = jQueryStamped('meta[itemprop="bestRating"]').attr('content');
            var worstRating = jQueryStamped('meta[itemprop="worstRating"]').attr('content');
            if (parseInt(ratingValue) > 0){
                aggregateRating.value = {
                    "@type": "AggregateRating",
                    "ratingValue": ratingValue,
                    "reviewCount": reviewCount,
                    "worstRating": worstRating,
                    "bestRating": bestRating,
                    "ratingCount": ratingCount,

                }
                let reviewSchema: {aggregateRating: any, reviewData: any[]} = {
                    aggregateRating: aggregateRating.value,
                    reviewData: [],
                }
                const reviews = jQueryStamped('.stamped-review');
                const reviewsArray = Object.values(reviews as HTMLElement[]);
                const totalReviews = reviewsArray.length;

                // Only hide reviews if Show More hasn't been expanded yet
                if (totalReviews > 3 && !isShowMoreExpanded) {
                    reviewsArray.forEach((reviewEl, index) => {
                        if (index >= 3 && reviewEl instanceof HTMLElement) {
                            reviewEl.style.display = 'none';
                        }
                    });
                    
                    // Hide pagination
                    const pagination = document.querySelectorAll('[class*="pagination"]');
                    pagination.forEach((pag) => {
                        (pag as HTMLElement).style.display = 'none';
                    });
                } else if (isShowMoreExpanded) {
                    // If Show More was already expanded, show all reviews and pagination
                    reviewsArray.forEach((reviewEl) => {
                        if (reviewEl instanceof HTMLElement) {
                            reviewEl.style.display = 'block';
                        }
                    });
                    
                    // Show pagination
                    const pagination = document.querySelectorAll('[class*="pagination"]');
                    pagination.forEach((pag) => {
                        (pag as HTMLElement).style.display = 'block';
                    });
                }

                // Handle Show More button visibility
                const stampedWidget = document.getElementById('stamped-main-widget');
                if (stampedWidget) {
                    const stampQuestion = stampedWidget.querySelector(".stamped-summary-actions-newquestion") as HTMLElement;
                    const stampReview = stampedWidget.querySelector(".stamped-summary-actions-newreview") as HTMLElement;

                    if (totalReviews > 3) {
                        // Create and show Show More button
                        const btn = setupShowMoreButton(stampQuestion, stampReview);
                        if (btn) {
                            if (isShowMoreExpanded) {
                                btn.style.display = 'none';
                            } else {
                                btn.style.display = 'block';
                            }
                        }
                    } else {
                        // Hide Show More button if 3 or fewer reviews
                        const existingBtn = document.getElementById('show-more-btn');
                        if (existingBtn) {
                            existingBtn.style.display = 'none';
                        }
                    }
                }

                if (Object.values(reviews).length > 0){
                    Object.values(reviews as HTMLElement[]).forEach((reviewEl: HTMLElement, index: number) => {
                        if (index < 5 && reviewEl instanceof HTMLElement){
                            const reviewAuthor = reviewEl.querySelector("strong.author") ? reviewEl.querySelector("strong.author")?.textContent : '';
                            const reviewDescription = reviewEl.querySelector("p.stamped-review-content-body") ? reviewEl.querySelector("p.stamped-review-content-body")?.textContent : '';
                            const reviewUrl = fullUrl;
                            const reviewPublisher = "SK Jewellery";
                            const reviewDateRaw = reviewEl.querySelector("div.created") ? reviewEl.querySelector("div.created")?.textContent : '';
                            const reviewDate = reviewDateRaw ? (() => {
                                const [day, month, year] = reviewDateRaw.split('/').map(Number);
                                return new Date(year, month - 1, day).toLocaleDateString('en-US');
                            })() : '';
                            const reviewRate = reviewEl.getAttribute("data-rating") ? reviewEl.getAttribute("data-rating") : '';
                            const reviewData = {
                                "@type": "Review",
                                "reviewBody": reviewDescription,
                                "description": reviewDescription,
                                "datePublished": reviewDate,
                                "url": reviewUrl,
                                "author": {
                                    "@type": "Person",
                                    "name": reviewAuthor,
                                },
                                "publisher": {
                                    "@type": "Organization",
                                    "name": reviewPublisher,
                                },
                                "reviewRating": {
                                    "@type": "Rating",
                                    "ratingValue": reviewRate,
                                    "bestRating": 5,

                                },
                            };
                            reviewDatas.value.push(reviewData);
                        }
                    });
                }
                reviewSchema.reviewData = reviewDatas.value;
                emit("handle-aggregate-rating", reviewSchema);
            }

        });
    });
</script>
